var Vue = require("vue");

var vm = new Vue({
  el: "#app",
  components: {
    "vue-html-editor": require("../src/vue-html-editor.js")
  },
  data: {
    text: "Hello World!"
  }
});



/*****************
 ** WEBPACK FOOTER
 ** ./demo/demo.js
 ** module id = 0
 ** module chunks = 0
 **/